import { router } from '@inertiajs/vue3'

import type { ProductModel } from '@/domains/products/types/models/ProductModel.types'
import type {
  AssociateBarcodesToProduct,
  ProductEnhanceRequest
} from '@/domains/products/types/requests/ProductRequests.types'

import { callProducts } from '@/domains/products/services'
import { useProductEnhancerStore } from '@/domains/products/store/use-product-enhancer-store/useProductEnhancerStore'
import { getFieldToEnhance } from '@/domains/products/types/requests/ProductRequests.types'

const enhanceExecute = async (payload: ProductEnhanceRequest) => {
  const productEnhancerStore = useProductEnhancerStore()

  return productEnhancerStore.enhance(payload)
}

const enhanceGenerateFullExecute = async (payload: Required<Pick<ProductEnhanceRequest, 'barcodes'>>) => {
  const _payload: ProductEnhanceRequest = {
    barcodes: payload.barcodes,
    with_lookup: true,
    fields_to_enhance: getFieldToEnhance()
  }

  return enhanceExecute(_payload).then(res => {
    if (!route().current('admin.products.new')) {
      router.get(route('admin.products.new'))
    }
    return res
  })
}

const associateVariantsToProductExecute = async (payload: AssociateBarcodesToProduct) => {
  const productResponse = await callProducts().show(payload.product)

  const _payload: ProductEnhanceRequest = {
    barcodes: payload.barcodes,
    with_lookup: true,
    product: productResponse.data.value as ProductModel,
    fields_to_enhance: getFieldToEnhance(['VARIANT_TYPE_OPTIONS', 'SKU_CODES'])
  }

  const enhanceResponse = await enhanceExecute(_payload)

  router.get(route('admin.products.edit', { product: payload.product.slug }))

  return enhanceResponse
}

export { enhanceGenerateFullExecute, associateVariantsToProductExecute }
